var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7211 0.711548H1.13014V27.7819H35.7211V0.711548Z",
    fill: "#37AB49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.721 11.913H32.6389V3.42383H19.8346V7.01677H9.03813V12.8817H1.13013V18.7467H10.6409V27.7643H15.8365V15.823H23.4451V21.688H29.0459V17.778H35.721V11.913Z",
    fill: "#52974D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3473 15.5237H29.0459V19.7683H34.3473V15.5237Z",
    fill: "#37AB49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0127 6.73499H19.7113V10.9796H25.0127V6.73499Z",
    fill: "#37AB49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.134 12.7761H5.83266V17.0207H11.134V12.7761Z",
    fill: "#37AB49"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13013 9.67627H35.721",
    stroke: "#444042",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13013 20.4023H35.721",
    stroke: "#444042",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0244 0.711548V9.6763",
    stroke: "#444042",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0244 19.962V27.7644",
    stroke: "#444042",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91093 9.81714V19.9619",
    stroke: "#444042",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3805 9.81714V19.9619",
    stroke: "#444042",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7211 0.711548H1.13014V27.7819H35.7211V0.711548Z",
    stroke: "#444042",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.a652cc580ce1aa28ea5038a5701f2164.svg";
export { ForwardRef as ReactComponent };